export const SET_IS_OPEN = 'SET_IS_OPEN'
export const SET_LOADING = 'SET_LOADING'
